// packages/viewport/src/listener.js
import { debounce } from "@wordpress/compose";
import { dispatch } from "@wordpress/data";
import { store } from "./store/index.mjs";
var addDimensionsEventListener = (breakpoints, operators) => {
  const setIsMatching = debounce(
    () => {
      const values = Object.fromEntries(
        queries.map(([key, query]) => [key, query.matches])
      );
      dispatch(store).setIsMatching(values);
    },
    0,
    { leading: true }
  );
  const operatorEntries = Object.entries(operators);
  const queries = Object.entries(breakpoints).flatMap(
    ([name, width]) => {
      return operatorEntries.map(([operator, condition]) => {
        const list = window.matchMedia(
          `(${condition}: ${width}px)`
        );
        list.addEventListener("change", setIsMatching);
        return [`${operator} ${name}`, list];
      });
    }
  );
  window.addEventListener("orientationchange", setIsMatching);
  setIsMatching();
  setIsMatching.flush();
};
var listener_default = addDimensionsEventListener;
export {
  listener_default as default
};
//# sourceMappingURL=listener.mjs.map
